/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import d3 from '../globalexports/d3.export';

export default {
  offsetForMax: 2,
  weatherFileFormat: '.svg',
  weatherIconsDirectory: 'static/img/weather/',
  whiteWeatherIconsDirectory: 'white/',
  defaultStart: 'KBTP',
  defaultEnd: 'KMYR',
  offsetForMin: 0.20,
  arrowWidth: 130,
  elevationJumpsForAirmet: 3,
  chartTimeOffset: 1000,
  resizeDebounce: 500,
  radarSliderResizeDebounce: 800,
  resizeMinorDebounce: 100,
  defaultGroundSpeed: 130,
  defaultTopPadding: 10,
  defaultProduct: 'MAV',
  defaultRuleset: 'r',
  defaultWidthMap: 15,
  defaultWidth: 15,
  gridTravelEtaLabelWidthThreshold: 80,
  gridTravelEtaLabelOffset: 10,
  cigCloudBlockHeight: 20,
  defaultShow12HourView: false,
  jsScrollSvgFactor: 1,
  planeDragHandle: 30,
  loaderRadius: 45,
  loaderTrackWidth: 6,
  loaderStrokeSpacing: 0,
  blackColorIconBackground: '#FFF779',
  loaderFillColor: '#34495E',
  loaderTrackColor: '#E97F2B',
  loaderTextColor: '#fff',
  mosValidTooltipPrefix: 'Forecast valid at ',
  metarValidTooltipPrefix: 'Observation valid at ',
  gridTooltipLeftRightThreshold: 4,
  drawGridAuditLine: false,
  jsScrollSliderCordovaOffset: 128,
  jsScrollSliderCordovaOffsetiPhoneX: 152,
  jsScrollSliderOffset: 108,
  gridTooltipContentWidth: 352,
  gridTooltipDefaultLeft: 160,
  gridTooltipDesktopDefaultLeft: 160,
  minimumCigForLowerFreezingLine: 500,
  visibilityTillWhatAltitude: 1000,
  logarithmicScaleTicks: [0.1, 400, 1000, 3000, 12000],
  linearScaleTicks: [0, 3000, 6000, 9000, 12000, 15000, 18000],
  linearScaleTicksOptions: {
    6000: [0, 3000, 6000],
    12000: [0, 3000, 6000, 9000, 12000],
    20000: [0, 3000, 6000, 9000, 12000, 15000, 18000],
  },
  ceilingRoundConfig: {
    l1: 3000,
    l2: 5000,
    nearestConfig: {
      l1: 100,
      l2: 500,
      l3: 1000,
    },
  },
  trendLineTooltipsCircleRadius: 3,
  freezingLineMinValue: 2,
  aloftBarbInitialColor: '#848884',
  aglTooltipPostfix: ' AGL',
  mslTooltipPostfix: ' MSL',
  calmWind: 'Calm',
  variableWind: 'Variable',
  sliderPlayTimer: 1500,
  bnd3Curve: d3.curveMonotoneX,
  aloftBarbOpacityShowBarb: 0.2,
  aloftBarbOpacityHideBarb: 0,
  yAxisRightMeteoWidthMobile: 12,
  yAxisRightMeteoWidthWeb: 25,
  yAxisRouteRightWidth: 25,
  yAxisLeftWidth: 26,
  yAxisLeftWidthiPad: 30,
  barbPaddingWeb: 22,
  gridRouteDotRadius: 6,
  gridLevelOfWeatherThreshold: 10,
  defaultAction: 'meteogram',
  sigmetColor: 'red',
  gridRouteLineColor: '#ffffff',
  barbPaddingMobile: 10,
  yTickLineOffset: 3,
  yLeftOffsetToHandleTooltip: 6,
  iconMultiplier: {
    default: 2,
    big: 4,
  },
  dateMode: {
    local: 'local',
    utc: 'utc',
  },
  aloftBarbTooltip: {
    rectColor: '#000000',
    textColor: '#ffffff',
    headwind: 'Headwind',
    tailwind: 'Tailwind',
  },
  aloftZeroWindConfig: {
    pathValue: 'M-5,0a5,5 0 1,0 10,0a5,5 0 1,0 -10,0',
    transform: {
      rotate: 0,
      scale: 1,
      translate: {
        x: 0,
        y: 0,
      },
    },
  },
  meteoCeilingChartPercent: 50,
  meteoCeilingChartPercentLandscape: 70,
  routeCeilingChartPercent: 82,
  cloudThreshold: {
    seperateThresholdAlt: 32000,
    level1: {
      threshold: 90,
      fl320threshold: 99,
      color: '#D5EBF8',
      opacity: 0.7,
    },
    level2: {
      threshold: 98,
      fl320threshold: 100,
      color: '#FFFFFF',
      opacity: 1,
    },
  },
  noDataFoundAirportMessage: 'No data found. Please select a different airport.',
  noDataFoundRouteMessage: 'No data found. Please select a different route.',
  invalidRoute: 'Invalid Route',
  serviceNotAvailableMessage: 'The resource you requested is currently unavailable.  Please try again later.',
  products: {
    lamp: {
      name: 'LAMP',
      shortDisplay: '1d',
      display_name: '1 day',
      num_column: 25,
    },
    mav: {
      name: 'MAV',
      shortDisplay: '3d',
      display_name: '3 day',
      num_column: 23,
    },
    twelvehours: {
      name: 'TWELVEHOURS',
      shortDisplay: '12h',
      display_name: '12 hour',
      num_column: 25,
    },
  },
  orientation: {
    landscape: 'landscape',
    portrait: 'portrait',
  },
  flightDots: {
    radius: 8, // Dots circle radius
    strokeWidth: 3,
    yOffest: 4.5,
  },
  flightDotsMobile: {
    radius: 5, // Dots circle radius
    strokeWidth: 1.5,
    yOffest: 3,
  },
  barbhead: {
    light: {
      orient: 'auto',
      markerHeight: 10,
      markerWidth: 10,
      refX: -14,
      refY: 1.8,
    },
    moderate: {
      orient: 'auto',
      markerHeight: 4,
      markerWidth: 2,
      refX: -9,
      refY: 2,
    },
  },
  windSpeed: {
    calm: {
      radius: 3,
      color: 'black',
      strokeWidth: 1,
    },
    mobileLight: {
      color: 'black',
      width: 0.5,
      arrowWidth: 15,
      tooltipOffset: 3,
      barbHead: 'barbheadLight',
    },
    tabletLight: {
      color: 'black',
      width: 0.5,
      arrowWidth: 25,
      tooltipOffset: 6,
      barbHead: 'barbheadLight',
    },
    light: {
      color: 'black',
      width: 0.5,
      arrowWidth: 30,
      tooltipOffset: 10,
      barbHead: 'barbheadLight',
    },
    moderate: {
      color: 'orange',
      width: 0.75,
      arrowWidth: 35,
      barbHead: 'barbheadModerate',
    },
    heavy: {
      color: 'red',
      width: 1,
      arrowWidth: 45,
      barbHead: 'barbheadHeavy',
    },
  },
  airmet_type: 'AIRMET',
  sigmet_type: 'SIGMET',
  outlook_type: 'OUTLOOK',
  sigmetsLayerKey: 'SIGMETs',
  gairmetsLayerKey: 'G-AIRMETs',
  radarsLayerKey: 'Radar',
  metarsLayerKey: 'METARs',
  windsLayerKey: 'Winds Aloft',
  windsLayerRouteKey: 'Winds Aloft Route',
  defaultSuppressedMets: ['TURB HI'],
  typesOfMetsForMapLayers: ['Winds Aloft', 'Winds Aloft Route', 'METARs', 'SIGMETs', 'G-AIRMETs', 'ICE', 'IFR', 'MT OBSC', 'TURB LO', 'TURB HI', 'LLWS', 'SFC WINDS', 'FZLVL'],
  rulesetLayerMap: ['Flight Category'],
  radarLayerMap: ['Radar', 'Storm Track'],
  flightCategoryKey: 'Flight Category',
  RadarFilterKey: 'Radar',
  stormTrackFilterKey: 'Storm Track',
  maxIFROrMtnWithourElevation: 1000,
  maxLLWSWithourElevation: 2000,
  flightRuleColorIfNull: 'gray',
  crosstrackUnit: ' XTK',
  gairmetConfig: {
    gairmetOffsetHoursFuture: 2.984, // 2h 59minutes
    gairmetOffsetHoursPast: 0, // 0h
    rectOpacity: 0.2,
    strokeWidth: 1.5,
    ceilingVis: {
      key: 'IFR',
      refKey: 'IFR',
      priority: 1,
      strokeColor: '#9A1A9A',
      strokeDashArray: [3, 3],
    },
    turbHigh: {
      key: 'TURB-HI',
      refKey: 'TURB HI',
      priority: 2,
      strokeColor: '#FC6621',
      strokeDashArray: [15, 10, 5, 10, 15],
    },
    turbLow: {
      key: 'TURB-LO',
      refKey: 'TURB LO',
      priority: 3,
      strokeColor: '#CC3E20',
      strokeDashArray: [15, 10, 5, 10, 15],
    },
    turb: {
      key: 'TURB',
      refKey: 'TURB',
      priority: 3,
      strokeColor: '#CC3E20',
      strokeDashArray: [3, 3],
    },
    icing: {
      key: 'ICE',
      refKey: 'ICE',
      priority: 4,
      strokeColor: '#0B24FB',
      strokeDashArray: [10, 4, 2, 4],
    },
    mtnObscn: {
      key: 'MT_OBSC',
      key2: 'MTN OBSCN',
      refKey: 'MT OBSC',
      priority: 5,
      strokeColor: '#FC28FC',
      strokeDashArray: [8, 5],
    },
    llWindShear: {
      key: 'LLWS',
      refKey: 'LLWS',
      priority: 6,
      strokeColor: '#973436',
      strokeDashArray: [15, 10, 5, 10],
    },
    sfcWinds: {
      key: 'SFC Winds',
      key2: 'SFC_WND',
      refKey: 'SFC WINDS',
      priority: 7,
      strokeColor: '#CA661A',
      strokeDashArray: [5, 10],
    },
    frzgLvl: {
      key: 'FZLVL',
      key2: 'FZL',
      key3: 'M_FZLVL',
      refKey: 'FZLVL',
      priority: 8,
      strokeColor: 'rgb(102, 102, 204)',
      strokeDashArray: [0, 0],
    },
    convectiveAirmet: {
      key: 'CONVECTIVE',
      refKey: 'CONVECTIVE',
      priorityAirmet: 9,
      prioritySigmet: 10,
      strokeColorAirmet: '#FFCC00',
      strokeColorSigmet: 'red',
      strokeDashArray: [0, 0],
    },
  },
  iPadOffsetMark: {
    metar: 2,
    mos: 3,
    route: 4,
  },
  iPhoneOffsetMark: {
    metar: 1.5,
    mos: 2.5,
    route: 3,
  },
  markOffset: {
    metar: 1,
    mos: 2,
    route: 4,
  },
  convectiveMaxThreshold: 45000,
  convectiveMaxThresholdDisplay: 'FL450+',
  windGradient: {
    xwdMinValue: 0,
    xwdMaxValue: 20,
    wspMinValue: 0,
    wspMaxValue: 30,
    gradientConfig: [{
      offsetXwd: '0',
      offsetWsp: '0',
      color: '#4DC546',
    }, {
      offsetXwd: '0.50',
      offsetWsp: '0.333',
      color: '#4DC546',
    }, {
      offsetXwd: '.51',
      offsetWsp: '0.34',
      color: '#DFC837',
    }, {
      offsetXwd: '.750',
      offsetWsp: '0.66',
      color: '#DFC837',
    }, {
      offsetXwd: '.766',
      offsetWsp: '0.67',
      color: '#A62D59',
    }, {
      offsetXwd: '100%',
      offsetWsp: '100%',
      color: '#A62D59',
    }],
    gradientConfigArea: [{
      offsetXwd: '0',
      offsetWsp: '0',
      color: '#82d67d',
    }, {
      offsetXwd: '0.50',
      offsetWsp: '0.333',
      color: '#82d67d',
    }, {
      offsetXwd: '.51',
      offsetWsp: '0.34',
      color: '#e8d873',
    }, {
      offsetXwd: '.750',
      offsetWsp: '0.66',
      color: '#e8d873',
    }, {
      offsetXwd: '.766',
      offsetWsp: '0.67',
      color: '#c06c8a',
    }, {
      offsetXwd: '100%',
      offsetWsp: '100%',
      color: '#c06c8a',
    }],
  },
  temperature: {
    baseValueRule: {
      ruleStroke: {
        onLength: 10,
        offLength: 3,
      },
    },
    fahrenheit: {
      gradientConfig: [{
        offset: '0',
        color: '#E2E2E2',
      }, {
        offset: '.1249',
        color: '#E2E2E2',
      }, {
        offset: '.125',
        color: '#F274F2',
      }, {
        offset: '.1874',
        color: '#F274F2',
      }, {
        offset: '.1875',
        color: '#BD07BD',
      }, {
        offset: '.2499',
        color: '#BD07BD',
      }, {
        offset: '.25',
        color: '#610F6F',
      }, {
        offset: '.3124',
        color: '#610F6F',
      }, {
        offset: '.3125',
        color: '#4C4283',
      }, {
        offset: '.3749',
        color: '#4C4283',
      }, {
        offset: '.375',
        color: '#4961B7',
      }, {
        offset: '.4374',
        color: '#4961B7',
      }, {
        offset: '.4375',
        color: '#45A2A2',
      }, {
        offset: '.4999',
        color: '#45A2A2',
      }, {
        offset: '.5',
        color: '#4DC546',
      }, {
        offset: '.5624',
        color: '#4DC546',
      }, {
        offset: '.5625',
        color: '#B6D93F',
      }, {
        offset: '.6249',
        color: '#B6D93F',
      }, {
        offset: '.625',
        color: '#DFC837',
      }, {
        offset: '.6874',
        color: '#DFC837',
      }, {
        offset: '.6875',
        color: '#DD9242',
      }, {
        offset: '.7499',
        color: '#DD9242',
      }, {
        offset: '.75',
        color: '#D35364',
      }, {
        offset: '.8124',
        color: '#D35364',
      }, {
        offset: '.8125',
        color: '#A62D59',
      }, {
        offset: '.8724',
        color: '#A62D59',
      }, {
        offset: '.875',
        color: '#79163C',
      }, {
        offset: '.9999',
        color: '#79163C',
      }, {
        offset: '100%',
        color: '#37050D',
      }],
      gradientConfigArea: [{
        offset: '0',
        color: '#eeeeee',
      }, {
        offset: '.1249',
        color: '#eeeeee',
      }, {
        offset: '.125',
        color: '#f6a3f6',
      }, {
        offset: '.1874',
        color: '#f6a3f6',
      }, {
        offset: '.1875',
        color: '#d76ad7',
      }, {
        offset: '.2499',
        color: '#d76ad7',
      }, {
        offset: '.25',
        color: '#90579a',
      }, {
        offset: '.3124',
        color: '#90579a',
      }, {
        offset: '.3125',
        color: '#817aa8',
      }, {
        offset: '.3749',
        color: '#817aa8',
      }, {
        offset: '.375',
        color: '#7f90cc',
      }, {
        offset: '.4374',
        color: '#7f90cc',
      }, {
        offset: '.4375',
        color: '#7cbdbd',
      }, {
        offset: '.4999',
        color: '#7cbdbd',
      }, {
        offset: '.5',
        color: '#82d67d',
      }, {
        offset: '.5624',
        color: '#82d67d',
      }, {
        offset: '.5625',
        color: '#cbe478',
      }, {
        offset: '.6249',
        color: '#cbe478',
      }, {
        offset: '.625',
        color: '#e8d873',
      }, {
        offset: '.6874',
        color: '#e8d873',
      }, {
        offset: '.6875',
        color: '#e7b27a',
      }, {
        offset: '.7499',
        color: '#e7b27a',
      }, {
        offset: '.75',
        color: '#e08692',
      }, {
        offset: '.8124',
        color: '#e08692',
      }, {
        offset: '.8125',
        color: '#c06c8a',
      }, {
        offset: '.8724',
        color: '#c06c8a',
      }, {
        offset: '.875',
        color: '#a15b76',
      }, {
        offset: '.9999',
        color: '#a15b76',
      }, {
        offset: '100%',
        color: '#5e363d',
      }],
    },
    celsius: {
      gradientConfig: [{
        offset: '0',
        color: '#E2E2E2',
      }, {
        offset: '.1249',
        color: '#E2E2E2',
      }, {
        offset: '.125',
        color: '#F274F2',
      }, {
        offset: '.1874',
        color: '#F274F2',
      }, {
        offset: '.1875',
        color: '#BD07BD',
      }, {
        offset: '.2499',
        color: '#BD07BD',
      }, {
        offset: '.25',
        color: '#610F6F',
      }, {
        offset: '.3124',
        color: '#610F6F',
      }, {
        offset: '.3125',
        color: '#4C4283',
      }, {
        offset: '.3749',
        color: '#4C4283',
      }, {
        offset: '.375',
        color: '#4961B7',
      }, {
        offset: '.4374',
        color: '#4961B7',
      }, {
        offset: '.4375',
        color: '#45A2A2',
      }, {
        offset: '.4999',
        color: '#45A2A2',
      }, {
        offset: '.5',
        color: '#4DC546',
      }, {
        offset: '.5624',
        color: '#4DC546',
      }, {
        offset: '.5625',
        color: '#B6D93F',
      }, {
        offset: '.6249',
        color: '#B6D93F',
      }, {
        offset: '.625',
        color: '#DFC837',
      }, {
        offset: '.6874',
        color: '#DFC837',
      }, {
        offset: '.6875',
        color: '#DD9242',
      }, {
        offset: '.7499',
        color: '#DD9242',
      }, {
        offset: '.75',
        color: '#D35364',
      }, {
        offset: '.8124',
        color: '#D35364',
      }, {
        offset: '.8125',
        color: '#A62D59',
      }, {
        offset: '.8724',
        color: '#A62D59',
      }, {
        offset: '.875',
        color: '#79163C',
      }, {
        offset: '.9999',
        color: '#79163C',
      }, {
        offset: '100%',
        color: '#37050D',
      }],
      gradientConfigArea: [{
        offset: '0',
        color: '#eeeeee',
      }, {
        offset: '.1249',
        color: '#eeeeee',
      }, {
        offset: '.125',
        color: '#f6a3f6',
      }, {
        offset: '.1874',
        color: '#f6a3f6',
      }, {
        offset: '.1875',
        color: '#d76ad7',
      }, {
        offset: '.2499',
        color: '#d76ad7',
      }, {
        offset: '.25',
        color: '#90579a',
      }, {
        offset: '.3124',
        color: '#90579a',
      }, {
        offset: '.3125',
        color: '#817aa8',
      }, {
        offset: '.3749',
        color: '#817aa8',
      }, {
        offset: '.375',
        color: '#7f90cc',
      }, {
        offset: '.4374',
        color: '#7f90cc',
      }, {
        offset: '.4375',
        color: '#7cbdbd',
      }, {
        offset: '.4999',
        color: '#7cbdbd',
      }, {
        offset: '.5',
        color: '#82d67d',
      }, {
        offset: '.5624',
        color: '#82d67d',
      }, {
        offset: '.5625',
        color: '#cbe478',
      }, {
        offset: '.6249',
        color: '#cbe478',
      }, {
        offset: '.625',
        color: '#e8d873',
      }, {
        offset: '.6874',
        color: '#e8d873',
      }, {
        offset: '.6875',
        color: '#e7b27a',
      }, {
        offset: '.7499',
        color: '#e7b27a',
      }, {
        offset: '.75',
        color: '#e08692',
      }, {
        offset: '.8124',
        color: '#e08692',
      }, {
        offset: '.8125',
        color: '#c06c8a',
      }, {
        offset: '.8724',
        color: '#c06c8a',
      }, {
        offset: '.875',
        color: '#a15b76',
      }, {
        offset: '.9999',
        color: '#a15b76',
      }, {
        offset: '100%',
        color: '#5e363d',
      }],
    },
  },
  rlh: {
    stroke: 'rgb(119, 119, 255)',
  },
  windDomain: {
    min: 0,
    max: 20,
    minOffset: 0.1,
    maxOffset: 0.1,
  },
  ceilingDomain: {
    min: 0,
    max: 45000,
    minOffset: 100,
    maxOffset: 0,
  },
  precepitationDomain: {
    min: 0,
    max: 100,
    minOffset: 0.2,
    maxOffset: 2,
  },
  q06Domain: {
    min: 0,
    max: 2,
  },
  visDomain: {
    min: 0,
    max: 10,
    minOffset: 0.1,
    maxOffset: 0.03,
  },
  tmpDomain: {
    minOffset: 0,
    maxOffset: 10,
  },
  areaLineShift: {
    normal: -1,
    invert: 0.8,
  },
  gridBoxFormat: {
    formatA: '%H%M',
    formatB: '%H',
  },
  gridTickMinOffset: 50,
  GraphConfig: {
    rectOverlay: {
      radius: 2,
    },
    margin: {
      top: 36,
      right: 0,
      bottom: 54,
      left: 0,
    },
    marginIPad: {
      top: 36,
      right: 0,
      bottom: 48,
      left: 0,
    },
    marginMobile: {
      top: 36,
      right: 0,
      bottom: 28,
      left: 0,
    },
    majorXaxis: {
      offset: 12,
      negativeOffset: -24,
      middleZulu: '12',
      verticalLineZulu: '00',
    },
    zeroZulu: {
      shadeWidth: 80,
      shadeWidthMobile: 20,
      topFactor: -25,
    },
    trackLine: {
      minDistanceBtToolTip: 1,
      mobileOffsetMinDistanceToolTip: 4,
      OffsetMinDistanceToolTip: 2.8,
      hourAndFlightRuleOffset: 4,
      tooltipDataCircleRadius: 3,
    },
    topSpace: 15,
    mobileTopSpace: 8,
    yAxis: {
      tickPadding: 3,
      ticks: 2,
      ticks3: 3,
    },
    xAxis: {
      format: '%H',
      timePostFix: {
        zulu: 'Z',
        local: '',
      },
    },
    xAxis2: {
      format: '%a %-d %b',
    },
    mobileOffset: -15,
    noDataText: 'No data',
  },
  greaterThan: '>',
  lessThan: '<',
  visMaxThresholdTooltip: '6',
  visMinThresholdTooltip: '0.5',
  cigMinThresholdTooltip: 'SFC',
  precipMinThresholdTooltip: 15,
  st6MinThresholdTooltip: 5,
  precipNoneValuePlaceHolder: 1,
  noneTooltip: 'None',
  unlimitedTooltip: 'Unlimited',
  firstCigValue: 100, // This not sure we were using
  lastCigValue: 12000, // This not sure we were using
  firstVis: 0,
  lastVis: 10,
  mavDefsMap: {
    vis: {
      1: 0,
      2: 0.75,
      3: 1,
      4: 2,
      5: 3,
      6: 6,
      7: 10,
    },
    cig: {
      1: 100,
      2: 300,
      3: 700,
      4: 1500,
      5: 2500,
      6: 4000,
      7: 9000,
      8: 12000,
    },
    q06: {
      0: 0.0,
      1: 0.05,
      2: 0.17,
      3: 0.37,
      4: 0.75,
      5: 1.5,
      6: 2.0,
    },
    cigRange: {
      1: [1, 200],
      2: [201, 400],
      3: [500, 900],
      4: [1000, 1900],
      5: [2000, 3000],
      6: [3100, 6500],
      7: [6600, 12000],
      8: [12001, null],
    },
  },
  ChartLabelSpecs: {
    dew: {
      key: 'DEW',
      tooltip: {
        prefix: 'Dewpoint',
        unit: '\u00B0',
      },
    },
    alt: {
      key: 'ALT',
      tooltip: {
        prefix: 'Altimeter',
        unit: '"',
      },
    },
    tmp: {
      group: 4,
      key: 'TMP',
      tooltip: {
        prefix: 'Temp',
        unit: '\u00B0',
      },
      yAxis: 1,
      highLowVerticalSpace: 5,
      area: true,
      color: '#ff7f0e',
      areaColor: '#ff7f0e',
      values: [],
      sequence: 1,
    },
    rlh: {
      group: 4,
      key: 'RH',
      tooltip: {
        prefix: 'Rel Humid',
        unit: '%',
      },
      area: false,
      color: '#9191FF',
      yAxis: 2,
      values: [],
      sequence: 2,
    },
    wsp: {
      group: 3,
      key: 'WSP',
      tooltip: {
        prefix: 'Wind',
        unit: ' kt',
      },
      color: '#ff7f0e',
      yAxis: 1,
      values: [],
      sequence: 2,
    },
    xwd: {
      group: 3,
      key: 'XWD',
      tooltip: {
        prefix: 'Crosswind',
        unit: ' kt',
      },
      area: true,
      color: '#e57299',
      areaColor: '#ff98bb',
      yAxis: 1,
      values: [],
      sequence: 1,
    },
    wgs: {
      group: 3,
      key: 'WGS',
      tooltip: {
        prefix: 'Gust',
        unit: ' kt',
      },
      minValueRequiredToShow: 14,
      minDiffReqFromWsp: 5,
      minimumWspForMavToShowWgs: 12,
      minimumWgsForMavToShow: 25,
      gustWidth: 12,
      gustHeight: 3,
      gustHeightMobile: 2,
      area: false,
      color: '#0074a2',
      yAxis: 1,
      values: [],
      sequence: 3,
    },
    wdr: {
      group: 3,
      key: 'WDR',
      tooltip: {
        prefix: 'Wind Dir',
        unit: '\u00B0',
      },
      color: '#CCCCCC',
      yAxis: 2,
      values: [],
      sequence: 3,
    },
    p06: {
      group: 2,
      key: 'P06',
      tooltip: {
        prefix: '6hr Precip',
        unit: '%',
      },
      area: true,
      color: '#1F77B4',
      areaColor: '#52AAE7',
      yAxis: 1,
      values: [],
      minimumForDisplay: 2,
      addToReturnObject: false,
      sequence: 1,
    },
    ppo: {
      group: 2,
      key: 'PPO',
      tooltip: {
        prefix: 'Precip',
        unit: '%',
      },
      area: true,
      color: '#1F77B4',
      areaColor: '#52AAE7',
      yAxis: 1,
      values: [],
      minimumForDisplay: 2,
      addToReturnObject: false,
      sequence: 1,
    },
    t06: {
      group: 2,
      key: 'T06',
      tooltip: {
        prefix: '6hr T-storms',
        unit: '%',
      },
      area: true,
      color: '#e59400',
      areaColor: '#FFBF1A',
      yAxis: 1,
      values: [],
      minimumForDisplay: 2,
      addToReturnObject: false,
      sequence: 2,
    },
    t01: {
      group: 2,
      key: 'T01',
      tooltip: {
        prefix: '1hr T-storms',
        unit: '%',
      },
      area: true,
      color: '#e59400',
      areaColor: '#FFBF1A',
      yAxis: 1,
      values: [],
      minimumForDisplay: 2,
      addToReturnObject: false,
      sequence: 2,
    },
    cp2: {
      group: 2,
      key: 'cp2',
      tooltip: {
        prefix: '2hr T-storms',
        unit: '%',
      },
      area: true,
      color: '#e59400',
      areaColor: '#FFBF1A',
      yAxis: 1,
      values: [],
      minimumForDisplay: 2,
      addToReturnObject: false,
      sequence: 2,
    },
    st6: {
      group: 2,
      key: 'ST6',
      tooltip: {
        prefix: '6hr Severe T-storms',
        unit: '%',
      },
      area: true,
      color: '#cc0000',
      areaColor: '#FF4D4D',
      yAxis: 1,
      values: [],
      minimumForDisplay: 2,
      addToReturnObject: false,
      sequence: 3,
    },
    q06: {
      group: 2,
      key: 'Q06',
      tooltip: {
        prefix: '6hr Precip',
        unit: '"',
        mobileUnit: '"',
      },
      color: '#4D4DFF',
      yAxis: 2,
      values: [],
      minimumForDisplay: 0,
      addToReturnObject: false,
      sequence: 4,
    },
    sno: {
      group: 2,
      key: 'SNO',
      tooltip: {
        prefix: 'Snow',
        unit: '%',
      },
      area: true,
      color: '#FF69B4',
      areaColor: '#ff78bb',
      yAxis: 1,
      values: [],
      minimumForDisplay: 2,
      addToReturnObject: false,
      sequence: 5,
    },
    fzp: {
      group: 2,
      key: 'FZP',
      tooltip: {
        prefix: 'Freezing Precip',
        unit: '%',
      },
      area: true,
      color: '#7f345a',
      areaColor: '#8b486a',
      yAxis: 1,
      values: [],
      minimumForDisplay: 2,
      addToReturnObject: false,
      sequence: 6,
    },
    cig: {
      group: 1,
      key: 'CIG',
      tooltip: {
        prefix: 'Ceiling',
        unit: ' ft AGL',
        mobileUnit: 'K',
      },
      color: '#999999',
      areaColor: '#7EC0EE',
      area: true,
      yAxis: 1,
      values: [],
      sequence: 1,
    },
    elv: {
      group: 1,
      key: 'ELV',
      tooltip: {
        prefix: 'Elevation',
        unit: ' ft',
        mobileUnit: 'K',
      },
      color: '#8b4513',
      areaColor: '#8b4513',
      area: true,
      yAxis: 1,
      values: [],
      sequence: 3,
    },
    cigTmp: {
      group: 1,
      key: 'CIGTMP',
      tooltip: {
        prefix: 'Freezing level',
        unit: ' ft',
        mobileUnit: 'K',
      },
      color: '#1D62F0',
      areaColor: '#1D62F0',
      area: false,
      strokeWidth: 2,
      yAxis: 1,
      values: [],
      sequence: 1,
    },
    vis: {
      group: 1,
      key: 'VIS',
      tooltip: {
        prefix: 'Visibility',
        unit: ' sm',
        unitMeter: ' meters',
        unitKm: ' km',
      },
      yAxis: 2,
      area: false,
      areaColor: '#D8D8D8',
      values: [],
      color: '#FF9928',
      sequence: 2,
    },
  },
  gridView: {
    airportTextColor: '#ffffff',
    airportRectColor: '#4A4A4A',
    borderColor: 'silver',
    borderWidth: 0.8,
  },
  chartLabels: {
    rectStyling: {
      fill: '#fff',
      opacity: 0.5,
      transform: 'translate(0, 2)',
      rx: 2,
      ry: 2,
    },
    ceiling: {
      label: 'Clouds/Visibility',
      noAloftData: 'Winds and clouds aloft data not available.',
    },
    precepitation: {
      label: 'Precip',
      noSeriesLabel: 'No precip in forecast period',
    },
    winds: {
      label: 'Wind',
      noSeriesLabel: 'No wind in forecast period',
    },
    temps: {
      label: 'Temp/Humidity',
      noSeriesLabel: 'No temp in forecast period',
    },
  },
  xAxisAndChartDistance: 5,
  travelTimeRangeMinutes: 4320,
  travelTimeRangeDateFormat: '%a %-d %b %H%M',
  travelTimeRangeDateFormatLocal: '%a %-d %b %H:%M',
  mapKeyCreator: '%d%H%M',
  departurePrefix: 'ETD: ',
  arrivalPrefix: 'ETA: ',
  flightSliderMainPrefix: 'Time: ',
  slideRefreshDebounce: 0,
  sliderContainerHeight: 54,
  redrawRouteOnSlide: false,
  sliderOrientationDebounce: 500,
  ceilingClipPathReduction: 2,
  timeFormat: {
    local: '%H:%M',
    zulu: '%H%MZ',
  },
  dayFormat: ' %a %-d %b',
  aloftProgressBar: {
    topShift: 20,
    leftRightPadding: 50,
  },
  xAxis: {
    format: '%H%M',
    formatLocal: '%H:%M',
  },
  altitude: {
    prefix: 'AGL',
    postfix: 'ft',
  },
  noValueText: '--',
  planeSource: 'static/img/plane.svg', // Reading content planePath key will be created
  ceilingCloudOptionToUse: 2,
  drawSvgCeilingCloud: true,
  ceilingAreaBackgroundColor: '#7EC0EE',
  cloudOptions: {
    1: {
      cloudSource: 'static/img/clouds/cloud1.svg', // Reading content cloudPath key will be created
      xOffset: 13.5,
      yOffset: 30,
      scale: 0.3,
      fill: '#FFFFFF',
      stroke: '#D8EDF2',
      strokeWidth: '3px',
      interval: 20,
      mobileInterval: 30,
    },
    2: {
      cloudSource: 'static/img/clouds/cloud2.svg',
      xOffset: 4.5,
      yOffset: 5,
      scale: 0.09,
      fill: '#FFFFFF',
      stroke: '#FFFFFF',
      strokeWidth: '0px',
      interval: 5,
      mobileInterval: 40,
    },
    3: {
      cloudSource: 'static/img/clouds/cloud3.svg',
      xOffset: 13.5,
      yOffset: 15,
      scale: 0.3,
      fill: '#FFFFFF',
      stroke: '#D8EDF2',
      strokeWidth: '3px',
      interval: 20,
      mobileInterval: 30,
    },
  },
  planeConfig: {
    offset: 20,
    scale: 0.8,
    mapScale: 0.9,
    mapOffset: 20,
  },
  planeConfigMobile: {
    offset: 14.5,
    scale: 0.6,
    mapScale: 0.8,
    mapOffset: -22,
  },
  mouseTrackerPlaneOffset: 20,
  shadesForVisibility: {
    1: 'rgba(255, 255, 255, 1)',
    2: 'rgba(255, 255, 255, 0.8)',
    3: 'rgba(255, 255, 255, 0.6)',
    4: 'rgba(255, 255, 255, 0.4)',
    5: 'rgba(255, 255, 255, 0.2)',
    6: 'rgba(255, 255, 255, 0.1)',
    7: 'rgba(255, 255, 255, 0)', // Max visibility is white color with 0 opacity i.e. transparent
  },
};
